import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';

import greenLogo from '../../assets/images/greenLogo.png'

function Navbar() {

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor: 'var(--green)' }}>
      <div className="container">
        <Link className="navbar-brand" to='/'>
          <img src={greenLogo} alt="greenLogo" />
        </Link>

        <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-label="Toggle navigation"
        onClick={toggleMenu}
      >
        <i className={isOpen ? 'bi bi-x' : 'bi bi-list-nested'}></i>
      </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav m-auto">
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                الصفحة الرئيسية
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                من نحن
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/whyUs"
                className={`nav-link ${location.pathname === '/whyUs' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                لماذا نحن
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/services"
                className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                الخدمات
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                اعطنا رأيك
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
